import {
  Divider,
  HStack,
  Image,
  Link,
  useBreakpointValue,
  VStack,
} from "@chakra-ui/react";
import { appleStoreIcon, mobileBoard, playStoreIcon } from "assets/images";
import React from "react";

const MobileLinks: React.FC = () => {
  const imageWidth = useBreakpointValue({ base: "100%", md: "65%" });

  return (
    <VStack w={imageWidth} h={"100%"}>
      <Image
        src={mobileBoard}
        objectFit="contain"
        h={"80%"}
        // bgColor={"red"}
      />

      <HStack
        justify={"center"}
        align={"center"}
        gap={10}
        w="40%"
        // mt={"-200px"}
      >
        <Link
          href="https://apps.apple.com/ae/app/quran-al-kareem-%D9%82%D8%B1%D8%A2%D9%86-%D8%A7%D9%84%D9%83%D8%B1%D9%8A%D9%85/id6737459298" // pro
          // href="https://apps.apple.com/ae/app/al-quran-al-kareem-audio/id6739159376" // audio
          isExternal
        >
          <Image src={appleStoreIcon} objectFit="contain" />
        </Link>

        <Divider orientation="vertical" h="full" />

        <Link
          href="https://play.google.com/store/apps/details?id=com.alquran.quranpro"
          isExternal
        >
          <Image src={playStoreIcon} objectFit="contain" />
        </Link>
      </HStack>
    </VStack>
  );
};

export default MobileLinks;
